// Central service data - modify here to add/remove services or details
export const servicesData = [
  {
    id: "seguridad-salud",
    title: "Seguridad y Salud Ocupacional",
    color: "brunswick",
    icon: "🛡️",
    subtitle: "Asesoramiento integral en seguridad, higiene y salud ocupacional",
    highlights: [
      {
        title: "Evaluaciones integrales de riesgos",
        description: "Aplicación de metodologías avanzadas (HAZOP, What if?, FMEA, LOPA) para evaluar riesgos en procesos industriales."
      },
      {
        title: "Gerenciamiento de riesgos y programas de prevención",
        description: "Estrategias comprensivas de prevención adaptadas a cada organización."
      },
      {
        title: "Capacitaciones prácticas y teóricas",
        description: "Fortalecer la cultura de prevención en las organizaciones a través de programas especializados."
      },
      {
        title: "Evaluación de carga de fuego",
        description: "Análisis y diseño de medidas preventivas contra incendios."
      },
      {
        title: "Análisis de zonas de riesgo",
        description: "Clasificación y análisis de zonas para la implementación de medidas de seguridad específicas."
      },
      {
        title: "Planes integrales de autoprotección",
        description: "Programas adaptados a las necesidades específicas de cada organización."
      },
      {
        title: "Programas ergonómicos integrados",
        description: "Desarrollo de soluciones ergonómicas para mejorar las condiciones de trabajo."
      },
      {
        title: "Confección de programas de higiene y salud ocupacional",
        description: "Revisiones técnicas de equipos de izaje para asegurar su correcto funcionamiento y cumplimiento normativo."
      },
      {
        title: "Soporte técnico y legal",
        description: "Asesoramiento técnico y legal integral en materia de seguridad, higiene y salud ocupacional."
      }
    ]
  },
  {
    id: "evaluacion-ambiental",
    title: "Evaluación de Parámetros Ambientales y de Higiene Laboral",
    color: "apple",
    icon: "🌍",
    subtitle: "Servicio integral de recolección de muestras y análisis técnicos ejecutado por personal calificado",
    highlights: [
      {
        title: "Muestreo y estudio de suelos",
        description: "Determinación del estado del suelo y posibles riesgos ambientales."
      },
      {
        title: "Evaluación de calidad del agua",
        description: "Análisis de agua en acuíferos subterráneos y superficiales."
      },
      {
        title: "Medición de emisiones gaseosas",
        description: "Análisis de emisiones gaseosas para verificar el cumplimiento normativo."
      },
      {
        title: "Muestreo de efluentes líquidos",
        description: "Análisis de efluentes para verificar su tratamiento y cumplimiento normativo."
      },
      {
        title: "Caracterización de residuos",
        description: "Análisis de residuos sólidos y semisólidos para su gestión adecuada."
      },
      {
        title: "Monitoreo de contaminantes químicos",
        description: "Evaluación de contaminantes en espacios de trabajo según normativas vigentes."
      },
      {
        title: "Mapas de ruido y exposición sonora",
        description: "Elaboración de mapas de ruido y medición de exposición sonora personal."
      },
      {
        title: "Análisis de sistemas de iluminación",
        description: "Verificación según estándares de confort y seguridad."
      },
      {
        title: "Verificación de sistemas eléctricos",
        description: "Verificación de puesta a tierra y continuidad eléctrica."
      },
      {
        title: "Evaluación de cargas térmicas",
        description: "Análisis de cargas térmicas en ambientes laborales."
      },
      {
        title: "Medición de vibraciones",
        description: "Análisis y medición de vibraciones en espacios de trabajo."
      },
      {
        title: "Evaluación de sistemas de ventilación",
        description: "Verificación de ventilación para asegurar la calidad del aire en entornos industriales."
      },
      {
        title: "Informes técnicos detallados",
        description: "Elaboración de informes comparando resultados con estándares locales e internacionales."
      }
    ]
  },
  {
    id: "saneamiento-areas",
    title: "Análisis y Saneamiento de Áreas Contaminadas",
    color: "asparagus",
    icon: "🔬",
    subtitle: "Evaluación y remediación ambiental conforme a normas internacionales",
    highlights: [
      {
        title: "Análisis de Fase I (ASTM)",
        description: "Detección de potenciales impactos ambientales conforme a normas ASTM."
      },
      {
        title: "Estudios de Fase II",
        description: "Muestreo y análisis detallado para confirmar la presencia de contaminantes."
      },
      {
        title: "Diseño de planes de remediación",
        description: "Diseño e implementación de estrategias de remediación ambiental adaptadas a cada caso."
      },
      {
        title: "Cumplimiento normativo",
        description: "Aseguramiento del cumplimiento con normativas locales e internacionales en todos los procesos."
      }
    ]
  },
  {
    id: "cumplimiento-tecnico-legal",
    title: "Asesoría en Cumplimiento Técnico-Legal",
    color: "blue",
    subtitle: "Auditorías completas y asesoramiento en normativas legales y técnicas",
    highlights: [
      {
        title: "Auditorías de cumplimiento normativo",
        description: "Verificación completa del cumplimiento de normativas en ambiente, seguridad industrial, higiene y salud laboral."
      },
      {
        title: "Matrices de obligaciones legales",
        description: "Creación y gestión de matrices que recopilan las obligaciones legales en ambiente, seguridad, transporte y calidad."
      },
      {
        title: "Monitoreo de legislación",
        description: "Monitoreo y actualización constante de legislación a través de plataforma en línea con amplia cobertura nacional."
      },
      {
        title: "Asesoramiento en sanciones",
        description: "Asesoramiento experto en cuestiones legales y técnicas vinculadas a sanciones administrativas y penales en materia ambiental."
      },
      {
        title: "Due diligence ambiental",
        description: "Evaluación de riesgos y cumplimiento normativo mediante due diligence ambiental y laboral."
      },
      {
        title: "Capacitación en legislación",
        description: "Programas de capacitación en legislación ambiental dirigidos a líderes y directivos."
      },
      {
        title: "Trámites ante organismos",
        description: "Asesoramiento en trámites y gestiones ante organismos públicos y privados en todos los niveles administrativos."
      },
      {
        title: "Sistemas de gestión ISO",
        description: "Asesoramiento especializado en adopción de sistemas de gestión ISO 9001, 14001 y 45001."
      }
    ]
  },
  {
    id: "tramites-permisos",
    title: "Trámites de Permisos Locales, Provinciales y Nacionales",
    color: "apple",
    subtitle: "Gestión integral de permisos y autorizaciones ambientales",
    highlights: [
      {
        title: "Estudios de impacto ambiental",
        description: "Confección de estudios de impacto ambiental en iniciativas industriales o comerciales."
      },
      {
        title: "Auditorías de cumplimiento",
        description: "Auditorías de evaluación de cumplimiento normativo y propuesta de plan de mejoras en gestión ambiental."
      },
      {
        title: "Categorizaciones industriales",
        description: "Clasificación y categorización de actividades industriales según normativas ambientales."
      },
      {
        title: "Registro de residuos peligrosos",
        description: "Registro de operadores y generadores que manejan o producen residuos peligrosos."
      },
      {
        title: "Permisos de emisiones",
        description: "Evaluación y permisos relacionados con emisiones gaseosas y calidad del aire."
      },
      {
        title: "Prefactibilidades hídricas",
        description: "Análisis y evaluación de factibilidad hídrica para proyectos industriales."
      },
      {
        title: "Permisos de vertido",
        description: "Gestión de permisos relacionados con el vertido de efluentes líquidos."
      },
      {
        title: "Licencias de agua",
        description: "Licencias para el aprovechamiento de aguas superficiales y subterráneas."
      },
      {
        title: "Aptitudes hidráulicas",
        description: "Evaluación y obtención de aptitudes hidráulicas necesarias."
      },
      {
        title: "Habilitación de zonas industriales",
        description: "Gestión de trámites para la habilitación de zonas industriales."
      },
      {
        title: "Tramitación general",
        description: "Tramitación de permisos y habilitaciones ante organismos municipales, provinciales y nacionales."
      },
      {
        title: "Planos y proyectos",
        description: "Elaboración y presentación de planos para proyectos civiles, electromecánicos, contra incendios y sanitarios."
      }
    ]
  },
  {
    id: "sustentabilidad-ambiental",
    title: "Sustentabilidad Ambiental",
    color: "asparagus",
    subtitle: "Evaluación y optimización de impacto ambiental",
    highlights: [
      {
        title: "Huella de carbono e hídrica",
        description: "Evaluación y cálculo de la huella hídrica y de carbono con planes de acción y capacitaciones especializadas."
      },
      {
        title: "Optimización de recursos",
        description: "Implementación de planes que optimizan el uso de recursos hídricos y energéticos en organizaciones."
      },
      {
        title: "Estrategias de sostenibilidad",
        description: "Desarrollo de estrategias integrales de sostenibilidad ambiental adaptadas a cada sector."
      },
      {
        title: "Transición hacia energías limpias",
        description: "Asesoramiento en implementación de fuentes de energía renovable y transición energética."
      }
    ]
  }
];
